const GA4_QUERY_PARAM_NAMES = new Set([
    "_ga",
    "_gl",
    "dclid",
    "gbraid",
    "gclid",
    "wbraid",
]);

export function isGA4QueryParam(queryParamName: string) {
    return queryParamName.startsWith("utm_") || queryParamName.startsWith("gad_") || GA4_QUERY_PARAM_NAMES.has(queryParamName);
}

export function preserveGA4QueryParams(
    redirectUrl: string,
    currentSearch = window.location.search,
    baseUrl = window.location.origin
) {
    if (!redirectUrl) {
        return redirectUrl;
    }

    try {
        const currentParams = new URLSearchParams(currentSearch);
        const paramsToPreserve: string[] = [];
        currentParams.forEach((_value, queryParamName) => {
            if (isGA4QueryParam(queryParamName) && !paramsToPreserve.includes(queryParamName)) {
                paramsToPreserve.push(queryParamName);
            }
        });

        if (paramsToPreserve.length === 0) {
            return redirectUrl;
        }

        const url = new URL(redirectUrl, baseUrl);
        paramsToPreserve.forEach(queryParamName => {
            if (url.searchParams.has(queryParamName)) {
                return;
            }

            currentParams.getAll(queryParamName).forEach(value => url.searchParams.append(queryParamName, value));
        });

        return `${url.pathname}${url.search}${url.hash}`;
    } catch {
        return redirectUrl;
    }
}
